import { useState, useEffect } from "react";
import type { MaintenanceResponse, MaintenanceWindow } from "../../types/incidents";
import { apiFetch } from "../../lib/config";

function relativeEnd(isoDate: string): string {
  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
  const diff = (new Date(isoDate).getTime() - Date.now()) / 1000;
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ["day", 86400],
    ["hour", 3600],
    ["minute", 60],
    ["second", 1],
  ];
  for (const [unit, seconds] of units) {
    if (Math.abs(diff) >= seconds || unit === "second") {
      return rtf.format(Math.round(diff / seconds), unit);
    }
  }
  return isoDate;
}

function formatDateRange(window: MaintenanceWindow): string {
  const start = new Date(window.starts_at).toLocaleString();
  const end = new Date(window.ends_at).toLocaleString();
  return `${start} – ${end}`;
}

export function MaintenanceSection() {
  const [maintenance, setMaintenance] = useState<MaintenanceResponse | null>(null);

  useEffect(() => {
    apiFetch("/api/v1/maintenance/")
      .then((r) => r.json())
      .then(setMaintenance)
      .catch(() => null);
  }, []);

  if (!maintenance) return null;
  if (maintenance.active.length === 0 && maintenance.upcoming.length === 0) return null;

  return (
    <section className="aptean-maintenance-section" aria-label="Maintenance windows">
      <h2 className="aptean-maintenance-section__heading">Scheduled Maintenance</h2>

      {maintenance.active.map((w) => (
        <div key={w.id} className="aptean-maintenance-section__window aptean-maintenance-section__window--active">
          <span className="aptean-maintenance-section__label">In progress</span>
          <strong>{w.title}</strong>
          <span className="aptean-maintenance-section__ends">
            {" "}(ends {relativeEnd(w.ends_at)})
          </span>
        </div>
      ))}

      {maintenance.upcoming.map((w) => (
        <div key={w.id} className="aptean-maintenance-section__window aptean-maintenance-section__window--upcoming">
          <strong>{w.title}</strong>
          <span className="aptean-maintenance-section__schedule">
            {" "}scheduled for {formatDateRange(w)}
          </span>
        </div>
      ))}
    </section>
  );
}
